import Vue from 'vue';
import CitiesSelector from "../../components/CitiesSelector";
import AnchorsApp from "../../components/AnchorsApp";

let els;

if ((els = document.querySelectorAll('.nav-app')).length > 0) {
	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		new Vue({
			el,
			name: 'NavApp',
			components: { CitiesSelector, AnchorsApp },
			data() {
				return {
					cities: [],
					opened: false,
					city: false
				}
			},
			methods: {
				toggle() {
					this.opened = !this.opened;
				}
			}
		});
	}
}
